import { ProductionSteps } from 'scenario/ScenarioType';

export const isF55Disabled = (productionSteps?: ProductionSteps): boolean =>
  !(productionSteps === ProductionSteps.F55 || productionSteps === ProductionSteps.DMHAndF55);

export const isDMHDisabled = (productionSteps?: ProductionSteps): boolean =>
  !(productionSteps === ProductionSteps.DMH || productionSteps === ProductionSteps.DMHAndF55);
